module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/plan1-3-011ace9dd3f9d8aba8e0cca732f0ce6f.webp";